<template>
    <div id="desktop-nav" class="nav--desktop layout__aside__nav">
        
        <a href="#content" tabindex="1" class="skip-nav-link">
            <div class="primary-text secondary-background">
                {{ skipLinkText }}
            </div>
        </a>

        <ul class="nav--desktop__list primary-text">
            <li v-for="element in nav.elements" class="nav--desktop__list-element"
                :class="{ 'fs-primarymenu huge': element.huge, 'fs-secondarymenu': !element.huge }">
                <a v-if="!element.child"
                   class="nav-element"
                   :href="element.url || '#'"
                >
                    {{ element.name }}
                </a>
                <button v-else
                        type="button"
                        class="nav-element"
                        aria-haspopup="dialog"
                        @click="openSubMenu(element)"
                >
                    {{ element.name }}
                </button>
            </li>
            <li class="nav--desktop__list-element nav--desktop__list-element--search">
                <button type="button"
                        class="button-link fs-secondarymenu"
                        aria-haspopup="dialog"
                        @click="open = true; search = true"
                >
                    {{ searchLabel }} <i class="icon-search" aria-hidden="true"></i>
                </button>
            </li>
        </ul>
        <app-nav :nav="nav"
                 :current="current"
                 :display-back="false"
                 :hide-footer="true"
                 :no-animation="true"
                 :open="open"
                 :search="search"
                 @next="current = $event"
                 @close="open = false"
                 @open-search="search = true"
                 @close-search="search = false"
        ></app-nav>
    </div>
</template>

<script>
    import { isOnDanish } from './../utils/is-on-language';
    import { getNavData } from './utils';
    import getSearchLabel from './search-label';

    export default {
        data () {
            return {
                nav: getNavData(),
                current: getNavData(),
                open: false,
                search: false,
                searchLabel: getSearchLabel(),
                skipLinkText: isOnDanish() ? 'hop til indhold' : 'jump to content'
            };
        },
        methods: {
            openSubMenu (element) {
                this.current = element.child;
                this.open    = true;
                this.search  = false;
            },
        },
    };
</script>
